import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 0,
    marginBottom: 0,
    borderTop: '0.5px solid black',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '0.5px solid black',
    padding: 10
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 0,
    padding: 10,
    borderTop: '0.5px solid black',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '0.5px solid black'
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5,
    minHeight: '100px'
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '12.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  tableCell: {
    fontSize: 10
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const DischargeSummaryPDF = ({ data }) => {
  console.log(data);

  const medicines = data?.medicines || [];

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`Discharge Summary`}>
          <Page size="A4" style={styles.page}>
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '50%', height: '50px', marginBottom: 20, marginLeft: '120px' }}
            />
            <View style={styles.row}>
              <Text content="Discharge Summary" style={{ fontSize: '12px', margin: '0 auto' }} />
            </View>
            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Patient Name     : " style={styles.textBold} />
                </View>
                <View style={styles.row}>
                  <Text content="Address       :" style={styles.textBold} />
                </View>
                <View style={styles.row}>
                  <Text content="UHID No.      :" />
                </View>
                <View style={styles.row}>
                  <Text content="Mob No.          :" />
                </View>
                <View style={styles.row}>
                  <Text content="Admission Date      : " />
                </View>
                <View style={styles.row}>
                  <Text content="Room No.             :" />
                </View>
                <View style={styles.row}>
                  <Text content="Consultant                :" />
                </View>
              </View>
              <View style={styles.column}></View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Age/Sex           :" />
                </View>
                <View style={styles.row}>
                  <Text content="IPD No.                 :" />
                </View>
                <View style={styles.row}>
                  <Text content="Discharge Date    : " />
                </View>
                <View style={styles.row}>
                  <Text content="Ward    : " />
                </View>
                <View style={styles.row}>
                  <Text content="Category    : " />
                </View>
                <View style={styles.row}>
                  <Text content="Department   : " />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer2}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Final Diagnosis      :" style={styles.textBold} />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer2}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Presenting Symptoms & Duration : " style={styles.textBold} />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer2}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Investigation: " style={styles.textBold} />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer2}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Local Examination: " style={styles.textBold} />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer2}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Course In Hospital: " style={styles.textBold} />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer2}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Condition In Discharge: " style={styles.textBold} />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer2}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Advise On Discharged: " style={styles.textBold} />
                </View>
              </View>
            </View>

            {/* Table */}
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="  Discharge Medicine" />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Frequency" />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Morning" />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Noon" />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Evening" />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Night" />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Days" />
                </View>
              </View>
              {/* Add table rows dynamically here based on data */}
              {medicines.map((medicine, index) => (
                <View style={styles.tableRow} key={index}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell} content={medicine.name} />
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell} content={medicine.frequency} />
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell} content={medicine.morning} />
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell} content={medicine.noon} />
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell} content={medicine.evening} />
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell} content={medicine.night} />
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell} content={medicine.days} />
                  </View>
                </View>
              ))}
            </View>

            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Prepared By    : " style={styles.textBold} />
                </View>
                <View style={styles.row}>
                  <Text content="Next Follow Time      :" />
                </View>
              </View>
              <View style={styles.column}></View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="(Doctor Name)                :" />
                </View>
                <View style={styles.row}>
                  <Text content="Consultant Doctor & Sign               :" />
                </View>
              </View>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
